import React from 'react';
import { PropTypes } from 'prop-types';
import {
  deliveryNotesFileExtensionsButton,
  laboratoryFileExtensionsButton,
} from '../../constants/general';
import { useIntl } from 'react-intl';
import styles from './index.module.scss';

const { button } = styles;

const AccionaUploadButton = ({ onClick, msg, type, id }) => {
  const intl = useIntl();
  const fileUploadHandler = (msg) => {
    document.getElementById(`fileSelector-${msg}`).click();
  };
  return (
    <button
      className={button}
      onClick={() => fileUploadHandler(msg)}
      id={id}
      title={intl.formatMessage({ id: 'createAction.template' })}
    >
      <i className="icon fas fa-plus"></i>
      <input
        accept={
          type === 'deliveryNote'
            ? deliveryNotesFileExtensionsButton
            : laboratoryFileExtensionsButton
        }
        hidden
        id={`fileSelector-${msg}`}
        type="file"
        onChange={onClick}
      />
      {intl.formatMessage({ id: msg })}
    </button>
  );
};

AccionaUploadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  msg: PropTypes.string,
  type: PropTypes.oneOf(['deliveryNote', 'laboratory']),
  id: PropTypes.string,
};

AccionaUploadButton.defaultProps = {
  onClick: () => {},
  msg: 'UPLOAD',
  type: 'deliveryNote',
  id: 'AccionaUploadButton',
};

export default AccionaUploadButton;
